import React from 'react'
import { useTranslation } from 'react-i18next'
import './footer.css'
import { FaFacebookF, FaGithub, FaLinkedinIn } from 'react-icons/fa'
import { FiInstagram } from 'react-icons/fi'
import { IoLogoTwitter } from 'react-icons/io'
import { FiDribbble } from 'react-icons/fi'

const Footer = () => {
  const { t } = useTranslation()

  const links = [
    { href: '#about', key: 'about' },
    { href: '#process', key: 'process' },
    { href: '#services', key: 'services' },
    { href: '#portfolio', key: 'portfolio' },
    { href: '#contact', key: 'contact' },
  ]

  const socials = [
    { href: 'https://facebook.come', icon: FaFacebookF },
    { href: 'https://instagram.come', icon: FiInstagram },
    { href: 'https://twitter.come', icon: IoLogoTwitter },
    { href: 'https://linkedin.com', icon: FaLinkedinIn },
    { href: 'https://github.com', icon: FaGithub },
    { href: 'https://dribbble.com', icon: FiDribbble },
  ]

  return (
    <footer>
      <div className="container footer__inner">
        <div className="footer__brand">
          <span className="footer__name">UNICodes</span>
          <p>{t('hero.subtitle')}</p>
        </div>

        <div className="footer__links">
          {links.map(({ href, key }) => (
            <a key={key} href={href}>{t(`nav.${key}`)}</a>
          ))}
        </div>

        <div className="footer__socials">
          {socials.map(({ href, icon: Icon }) => (
            <a key={href} href={href} target="_blank" rel="noopener noreferrer"><Icon /></a>
          ))}
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <small>&copy; {new Date().getFullYear()} {t('footer.copyright')}</small>
        </div>
      </div>
    </footer>
  )
}

export default Footer
